import { render } from "./WebApps.vue?vue&type=template&id=87c322cc"
import script from "./WebApps.vue?vue&type=script&lang=js"
export * from "./WebApps.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__